import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_FINANCIAL_MASKING_FEATURE_ENABLED is set to
// "true" on the server. Reads from the public /app-config endpoint so the
// flag is available pre-auth (the Chat Settings page hides the Financial
// Masking section, the FinancialMaskingSection itself short-circuits, and
// the org service mirrors the same guard server-side for direct API
// callers).
export const useFinancialMaskingFeatureEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isFinancialMaskingFeatureEnabled ?? false;
};
